import classNames from 'classnames';
import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { ResponsivePicture } from '../../ResponsivePicture/ResponsivePicture';
import { CooledProductsConflictItem } from '../CooledProductsConflictItem';
import { Info } from './Info';
import { isRxItem } from './IsRxItem';

interface MultipleProductsProps {
    products: CooledProductsConflictItem[];
    label?: string;
    pictureProfile: PictureProfile;
}
const ProductLimit = 6;
const MobileProductLimit = 4;

export const MultipleProducts = ({ products, label, pictureProfile }: MultipleProductsProps) => (
    <>
        <div className="CooledProductsConflictEntry__Pictures">
            {products.slice(0, products.length > ProductLimit ? ProductLimit - 1 : ProductLimit).map((x, i) => {
                const isRx = isRxItem(x);

                return (
                    <div
                        key={x.code}
                        className={classNames('CooledProductsConflictEntry__Picture', {
                            hideOnMobile: i + 1 > MobileProductLimit
                        })}
                    >
                        {isRx ? (
                            <iframe src={x.imageUrl} scrolling="no" sandbox="allow-same-origin" />
                        ) : (
                            <ResponsivePicture profile={pictureProfile} model={x.image} />
                        )}
                    </div>
                );
            })}
            {products.length > MobileProductLimit && (
                <div className="CooledProductsConflictEntry__Placeholder hideOnDesktop">+{products.length - MobileProductLimit}</div>
            )}
            {products.length > ProductLimit && <div className="CooledProductsConflictEntry__Placeholder hideOnMobile">+{products.length - ProductLimit}</div>}
        </div>
        {label && (
            <div className="CooledProductsConflictEntry__Data">
                <Info label={label} isCooled={products[0].isCooled} />
            </div>
        )}
    </>
);
